import { upperFirst, camelCase } from 'lodash'

const files = require.context('./types', false, /\.js$/)
const modules = {};

files.keys().forEach((key) => {
  if (key === './enum.js') return;
  const kebab = key.replace(/(\.\/|\.js)/g, '');
  modules[ upperFirst(camelCase(kebab)) ] = files(key).default
});

export default modules
